// Only gate attendee/expert routes. Keep moderator and unrelated pages unchanged.
const meetingRoutes = new Set(['welcome', 'host', 'visitor', 'appPage'])

export function shouldShowWeChatGuide(routeName, userAgent = globalThis.navigator?.userAgent || '') {
  return meetingRoutes.has(routeName) && /micromessenger/i.test(userAgent)
}
